import React from 'react';
import { Formik, Form } from 'formik';
import { AddContainer, Component6, Texts, LabelWithTooltip } from './Styles';
import SwitchComponent from 'src/components/shared/Form/Switch';
import { useDispatch } from 'react-redux';
import toast from 'src/utils/toast';
import { postCustomPatientFieldsRequest } from '../../../store/publicActions';

function CustomPatientFieldsStep({ innerRef, data, setClinicProfileData, clinicId }) {
  const dispatch = useDispatch();

  const initialValues = {
    height: data?.height ?? false,
    weight: data?.weight ?? false,
    postalAddress: data?.postalAddress ?? true,
    area: data?.area ?? true,
    city: data?.city ?? true,
    state: data?.state ?? true,
    aadhaarNumber: data?.aadhaarNumber ?? false,
  };

  const fields = [
    { key: 'height', label: 'Height', type: 'text' },
    { key: 'weight', label: 'Weight', type: 'number' },
    { key: 'postalAddress', label: 'Postal Address', type: 'text' },
    { key: 'area', label: 'Area', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'state', label: 'State', type: 'text' },
    { key: 'aadhaarNumber', label: 'Aadhaar card number', type: 'text' },
  ];

  const handleSubmit = (values) => {
    const customFieldsPayload = {
      clinicId: clinicId,
      fields: fields
        .filter(field => values[field.key]) // Only send enabled fields if "select only some details" means only including the ones selected
        .map(field => ({
          fieldName: field.key,
          label: field.label,
          type: field.type,
          required: false
        }))
    };

    setClinicProfileData((prev) => ({
      ...prev,
      customPatientFields: { ...values },
      formattedCustomPatientFields: customFieldsPayload.fields,
    }));

    // If no fields are selected, we might want to send an empty array or handle it.
    // However, the error says "must not be empty", so if the user selects none, we might need a fallback or alert.
    // For now, let's assume at least one is usually selected as per the screenshot.

    return new Promise((resolve, reject) => {
      if (!clinicId || String(clinicId).trim() === "") {
        // In onboarding flow, clinicId might not exist yet.
        // It will be saved during final submit.
        resolve(true);
        return;
      }

      dispatch(postCustomPatientFieldsRequest(customFieldsPayload, (res) => {
        toast.success('custom patient field should submitted successfully');
        resolve(res);
      }, (err) => {
        toast.error(err?.message || 'Failed to submit custom patient fields');
        reject(err);
      }));
    });
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={innerRef} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <AddContainer>
            {fields.map(({ key, label }) => (
              <Component6 key={key}>
                <Texts>
                  <LabelWithTooltip label={label} tooltip={`Enable to collect ${label} during patient onboarding/registration.`} />
                </Texts>
                <SwitchComponent
                  name={key}
                  checked={Boolean(values[key])}
                  onChange={() => setFieldValue(key, !values[key])}
                  sx={{ margin: 0, padding: 0 }}
                />
              </Component6>
            ))}
          </AddContainer>
        </Form>
      )}
    </Formik>
  );
}

export default CustomPatientFieldsStep;

